import React from "react";
import {useTranslation} from "react-i18next";
import FeatherIcon from "components/FeatherIcon";
import {openModal} from "helpers/actions";
import {ModalSize} from "pages/Front/components/Popup";
import {useDispatch} from "useDispatch";
import CreditCalculatorModal from "pages/Front/Booking/Credits/CreditCalculatorModal";

const PackageCreditCalculatorButton = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    ``;
    const openCreditCalculatorModal = () => {
        dispatch(openModal(<CreditCalculatorModal />, {modalSize: ModalSize.Scrollable}));
    };

    return (
        <button
            type={"button"}
            onClick={openCreditCalculatorModal}
            className={
                "PackageCreditCalculatorButton w-full xs:w-auto flex items-center justify-center gap-2 rounded-full border border-arbo-red bg-white px-3 py-2.5 text-xs font-semibold text-arbo-red hover:border-black/70 transition-colors"
            }
        >
            <FeatherIcon name={"info"} className={"size-4 flex-none"} />
            <span>{t("How many credits do I need?")}</span>
        </button>
    );
};

export default PackageCreditCalculatorButton;
